import { Checkbox } from '@/_components';

export function CellCheck({
  isChecked,
  check,
  label = 'Select row',
  className,
  disabled = false,
}: {
  isChecked: boolean;
  check: (v: boolean) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}) {
  return (
    <div className="-mb-0.5 pt-px">
      <Checkbox
        tabIndex={-1}
        disabled={disabled}
        checked={isChecked}
        className={className}
        onChange={({ target }) => {
          check(target.checked);
        }}
        aria-label={label}
      />
    </div>
  );
}
